import * as THREE from 'three'
import Project from './Project'
import gsap from 'gsap'

export default class ProjectsSection
{
    constructor(_options)
    {
        this.time = _options.time
        this.resources = _options.resources
        this.camera = _options.camera
        this.passes = _options.passes
        this.objects = _options.objects
        this.areas = _options.areas
        this.zones = _options.zones
        this.tiles = _options.tiles
        this.debug = _options.debug
        this.x = _options.x
        this.y = _options.y

        if(this.debug)
        {
            this.debugFolder = this.debug.addFolder('projects')
            this.debugFolder.open()
        }

        this.items = []

        this.interDistance = 24
        this.positionRandomess = 5
        this.projectHalfWidth = 9

        this.container = new THREE.Object3D()
        this.container.matrixAutoUpdate = false
        this.container.updateMatrix()

        this.setList()
        this.setGeometries()
        this.setMeshes()
        this.setZone()

        for(const _options of this.list)
        {
            this.add(_options)
        }
    }

    setGeometries()
    {
        this.geometries = {}
        this.geometries.floor = new THREE.PlaneGeometry(16, 8)
    }

    setMeshes()
    {
        this.meshes = {}

        this.resources.items.areaOpenTexture.magFilter = THREE.NearestFilter
        this.resources.items.areaOpenTexture.minFilter = THREE.LinearFilter
        this.meshes.boardPlane = this.resources.items.projectsBoardPlane.scene.children[0]
        this.meshes.areaLabel = new THREE.Mesh(new THREE.PlaneGeometry(2, 0.5), new THREE.MeshBasicMaterial({ transparent: true, depthWrite: false, color: 0xffffff, alphaMap: this.resources.items.areaOpenTexture }))
        this.meshes.areaLabel.matrixAutoUpdate = false
    }

    setList()
    {
        this.list = [
            {
                name: 'Rsgo',
                imageSources:
                    [
                        './models/projects/rsgo/slideA.png',
                        './models/projects/rsgo/slideB.png',
                        './models/projects/rsgo/slideC.png'
                    ],
                floorTexture: this.resources.items.projectsRsgoFloorTexture,
                link:
                    {
                        href: 'https://rsgo.io/',
                        x: - 4.8,
                        y: - 6,
                        halfExtents:
                            {
                                x: 3.2,
                                y: 1.5
                            }
                    }
            },
            {
                name: 'Sigma',
                imageSources:
                    [
                        './models/projects/sigma/slideA.png',
                        './models/projects/sigma/slideB.png',
                        './models/projects/sigma/slideC.png',
                        './models/projects/sigma/slideD.png'
                    ],
                floorTexture: this.resources.items.projectsSigmaFloorTexture,
                link:
                    {
                        href: 'https://sigma.ac/',
                        x: - 4.8,
                        y: - 6,
                        halfExtents:
                            {
                                x: 3.2,
                                y: 1.5
                            }
                    }
            },
            {
                name: 'Davlo',
                imageSources:
                    [
                        './models/projects/davloio/slideA.png',
                        './models/projects/davloio/slideB.png',
                        './models/projects/davloio/slideC.png'
                    ],
                floorTexture: this.resources.items.projectsDavloioFloorTexture,
                link:
                    {
                        href: 'https://davlo.io/',
                        x: - 4.8,
                        y: - 6,
                        halfExtents:
                            {
                                x: 3.2,
                                y: 1.5
                            }
                    }
            },
            {
                name: 'Intuition',
                imageSources:
                    [
                        './models/projects/intuition/slideA.png',
                        './models/projects/intuition/slideB.png',
                        './models/projects/intuition/slideC.png',
                        './models/projects/intuition/slideD.png'
                    ],
                floorTexture: this.resources.items.projectsIntuitionFloorTexture,
                link:
                    {
                        href: 'https://intuition.davlo.io/',
                        x: - 4.8,
                        y: - 6,
                        halfExtents:
                            {
                                x: 3.2,
                                y: 1.5
                            }
                    }
            },
            {
                name: 'Penumbra Indexer',
                imageSources:
                    [
                        './models/projects/penumbra/slideA.png',
                        './models/projects/penumbra/slideB.png',
                        './models/projects/penumbra/slideC.png',
                        './models/projects/penumbra/slideD.png'
                    ],
                floorTexture: this.resources.items.projectsPenumbraFloorTexture,
                link:
                    {
                        href: 'https://penumbra.davlo.io/',
                        x: - 4.8,
                        y: - 6,
                        halfExtents:
                            {
                                x: 3.2,
                                y: 1.5
                            }
                    }
            },
            {
                name: 'Marktplatz',
                imageSources:
                    [
                        './models/projects/marktplatz/slideA.png',
                        './models/projects/marktplatz/slideB.png',
                        './models/projects/marktplatz/slideC.png',
                        './models/projects/marktplatz/slideD.png'
                    ],
                floorTexture: this.resources.items.projectsMarktplatzFloorTexture,
                link:
                    {
                        href: 'https://bildungsmarktplatz.ch/',
                        x: - 4.8,
                        y: - 6,
                        halfExtents:
                            {
                                x: 3.2,
                                y: 1.5
                            }
                    }
            },
            {
                name: 'Rooms/',
                imageSources:
                    [
                        './models/projects/rooms/slideA.png',
                        './models/projects/rooms/slideB.png',
                        './models/projects/rooms/slideC.png'
                    ],
                floorTexture: this.resources.items.projectsRoomsFloorTexture,
            },
            {
                name: 'Tools/',
                imageSources:
                    [
                        './models/projects/tools/slideA.png',
                        './models/projects/tools/slideB.png',
                        './models/projects/tools/slideC.png'
                    ],
                floorTexture: this.resources.items.projectsToolsFloorTexture,
            },
            {
                name: 'Talent/',
                imageSources:
                    [
                        './models/projects/talent/slideA.png',
                        './models/projects/talent/slideB.png'
                    ],
                floorTexture: this.resources.items.projectsTalentFloorTexture,
            },
        ]
    }

    setZone()
    {
        const totalWidth = this.list.length * (this.interDistance / 2)

        const zone = this.zones.add({
            position: { x: this.x + totalWidth - this.projectHalfWidth - 6, y: this.y },
            halfExtents: { x: totalWidth, y: 12 },
            data: { cameraAngle: 'projects' }
        })

        zone.on('in', (_data) =>
        {
            this.camera.angle.set(_data.cameraAngle)
            gsap.to(this.passes.horizontalBlurPass.material.uniforms.uStrength.value, { x: 0, duration: 2 })
            gsap.to(this.passes.verticalBlurPass.material.uniforms.uStrength.value, { y: 0, duration: 2 })
        })

        zone.on('out', () =>
        {
            this.camera.angle.set('default')
            gsap.to(this.passes.horizontalBlurPass.material.uniforms.uStrength.value, { x: this.passes.horizontalBlurPass.strength, duration: 2 })
            gsap.to(this.passes.verticalBlurPass.material.uniforms.uStrength.value, { y: this.passes.verticalBlurPass.strength, duration: 2 })
        })
    }

    add(_options)
    {
        const x = this.x + this.items.length * this.interDistance
        let y = this.y
        if(this.items.length > 0)
        {
            y += (Math.random() - 0.5) * this.positionRandomess
        }

        const project = new Project({
            time: this.time,
            resources: this.resources,
            objects: this.objects,
            areas: this.areas,
            geometries: this.geometries,
            meshes: this.meshes,
            debug: this.debugFolder,
            x: x,
            y: y,
            ..._options
        })

        this.container.add(project.container)

        if(this.items.length >= 1)
        {
            const previousProject = this.items[this.items.length - 1]
            const start = new THREE.Vector2(previousProject.x + this.projectHalfWidth, previousProject.y)
            const end = new THREE.Vector2(project.x - this.projectHalfWidth, project.y)
            const delta = end.clone().sub(start)
            this.tiles.add({
                start: start,
                delta: delta
            })
        }

        this.items.push(project)
    }
}
